/** Split a free-text field into trimmed, non-empty items on semicolons and/or commas by default. */
export const splitList = (s, seps = /[;,]/) => (s ?? '').split(seps).map((x) => x.trim()).filter(Boolean);
